import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getGoogleSheetsQueryTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'service-account-email',
			selector: '[data-tour="service-account-email"]',
			content: 'Required: This is the service account email that is connected to the Google Sheet.',
		},
		{
			id: 'service-account-key',
			selector: '[data-tour="service-account-key"]',
			content:
				'Required: This is the private key generated for the service account. Normally you can find this in the JSON key file that is generated via the Google Cloud console. In the file the property is called "private_key".' +
				' Note That this values is populated via a Flow Parameter of type Key File.',
		},
		{
			id: 'spreadsheet-id',
			selector: '[data-tour="spreadsheet-id"]',
			content:
				'Required: This is the ID of the specific Google Sheet and can be found as part of the URL for the Google Sheet i.e. .../docs.google.com/spreadsheets/d/1JaZYgCs9wA7AhlyMsOGJi96nvMDnV05R0-4n3cPR8_8/edit?gid=0#gid=',
		},
		{
			id: 'selection-filter',
			selector: '[data-tour="selection-filter"]',
			content:
				'Required: This is the selection query for the data. It is using the Google Sheets query language as described here A1 Notation and R1C1 Notation',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
